import { useTranslation } from "react-i18next";
import {  Stack } from "@mui/material";
import "./CircleLoading.scss";
import "../../assets/scss/variables.scss";


//rename folder
const CircleLoading = (props: { loadingLabel?: string  }) => {
  const { t } = useTranslation("common");
  return (
    <Stack
      sx={{
        color: "#0250C1",
        alignItems: "center",
        padding: "40px 0px",
        display: "flex",
        justifyContent: "center"
      }}
      direction="column"
    >
      <div id="loader" style={{width:200 , height:200 }}></div>
      <span className="otp-loading-label" role="alert">
        {props.loadingLabel ? props.loadingLabel : t("general.loading")}
      </span>
    </Stack>
  );
};

export default CircleLoading;
